import AxiosClient from '../../../services/axios.services';

class WorkFlowBlockServices {
  getWorkFlowsBlocks = (params, type) => AxiosClient.get(type === 1 ? '/api/app/On_off_bording_bloque_plantilla/' : '/api/app/On_off_bording_bloque/', {
    headers: {'Content-Type': 'application/json'},
    params: params
  });
  
  getWorkFlowBlock = (id, type) => AxiosClient.get(type === 1 ? `/api/app/On_off_bording_bloque_plantilla/${id}` : `/api/app/On_off_bording_bloque/${id}`,{
    headers: {'Content-Type': 'application/json'}
  });

  saveWorkflowBlock = (data, type) => AxiosClient.post(type === 1 ? '/api/app/On_off_bording_bloque_plantilla/' : '/api/app/On_off_bording_bloque/', data, {
    headers: {'Content-Type': 'application/json'}
  });

  editWorkFlowBlock = (id, data, type) => AxiosClient.put(type === 1 ? `/api/app/On_off_bording_bloque_plantilla/${id}/` : `/api/app/On_off_bording_bloque/${id}/`, data, {
    headers: {'Content-Type': 'application/json'}
  });

  deleteWorkFlowBlock = (id, type) => AxiosClient.delete(type === 1 ? `/api/app/On_off_bording_bloque_plantilla/${id}/` : `/api/app/On_off_bording_bloque/${id}/`, {
    headers: {'Content-Type': 'application/json'}
  });  
}

export default new WorkFlowBlockServices();